/** 現在ページの origin（ビルド時フォールバックは REACT_APP_URL） */
export function siteOrigin(): string {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  const envUrl = process.env.REACT_APP_URL || "//beaver-delivery.com";
  return envUrl.startsWith("//") ? `https:${envUrl}` : envUrl;
}
